import type { OwnTransfer } from './OwnTransfer';

export const base: OwnTransfer = {
    enabledForLoans: false,
    isTermDepositToTermDepositTransferAllowed: true,
    isLoanAccountTransferAllowed: false,
    descriptionAttributeMapping: 'additionalInfo.paymentReference',
    descriptionMaxLength: 140,
    isDescriptionRequired: false,
    isSecondarySigneeSelectDisplayed: false,
    isCollectiveSigningInfoDisplayed: false,
    isSFondsInfoDisplayed: false,
    shouldSwitchDirectionByDefault: false,
    shouldCheckForPenaltyFreeAmount: false,
};
